<script>
import { EventBus } from '../../event-bus'
import { mapGetters } from 'vuex'
import { SCOF_FLOW } from '@/utils/constant'

export default {
  name: 'SaveCardInfo',
  props: {
    maskCardDetail: {
      type: Object,
      required: true
    },
    isCheckboxVisible: {
      type: Boolean
    }
  },
  data () {
    return {
      saveCard: false,
      enableSaveCard: this.isCheckboxVisible
    }
  },
  computed: {
    ...mapGetters([
      'saveMaskCard', 'scofExecutionFlow', 'enableNativeIntegrationFlow'
    ])
  },
  mounted () {
    EventBus.$on('enableSaveCardCheckbox', (event) => {
      this.enableSaveCard = [SCOF_FLOW.TXAV, SCOF_FLOW.TAV].includes(this.scofExecutionFlow) ? this.isCheckboxVisible : event
    })
  },
  methods: {
    toggleSaveCard (event) {
      EventBus.$emit('updateSaveCard', event.target.checked)
    }
  }
}
</script>

<template>
  <div
    id="card-payment-info"
    class="mb-4">
    <h6 class="mb-3">
      {{ $t("label.debitCreditCard") }}
    </h6>
    <div class="row">
      <div class="d-inline ml-3">
        <img
          :src="maskCardDetail.digitalCardData.artUri"
          alt="No Image"
          class="img-thumbnail card-logo"
        >
      </div>
      <div class="d-inline ml-3">
        <div
          v-if="maskCardDetail.panLastFour"
          class="text-break">
          <label>
            {{ $t("label.cardNumber") }}
          </label>
          <span
            id="card-number"
            data-test="card-number">
            ************{{ maskCardDetail.panLastFour }}
          </span>
        </div>
        <div
          v-if="
            maskCardDetail.panExpirationYear ||
              maskCardDetail.panExpirationMonth
          "
        >
          <label>
            {{ $t("label.cardExpiration") }}
          </label>
          <span
            id="card-expiration"
            data-test="card-expiration">
            {{ maskCardDetail.panExpirationMonth
            }}{{ maskCardDetail.panExpirationMonth ? "/" : ""
            }}{{ maskCardDetail.panExpirationYear }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="enableNativeIntegrationFlow === false && enableSaveCard"
      class="row mt-3 ml-4">
      <input
        id="saveCard"
        v-model="saveCard"
        data-test="saveCard"
        class="form-check-input"
        type="checkbox"
        @click="toggleSaveCard($event)"
      >
      <label
        for="saveCard"
        class="form-check-label ml-2">{{ $t ('label.saveCardForFuture') }}
      </label>
    </div>
  </div>
</template>
